import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of as observableOf } from 'rxjs';
import { AssetIndexTypes } from '../../../../../shared/enums/asset-index-types.enum';
import { Character, Department, Disposition, Field, Franchise, Location, Project, ProjectCurrency, Set, SubDepartment, Transaction } from '../../../core/store/models';

export interface CreateAssetFromTrxModalData {
    characters$: Observable<Character[]>;
    departments$: Observable<Department[]>;
    dispositions$: Observable<Disposition[]>;
    excludedDispositions$: Observable<Disposition[]>;
    franchise: Franchise;
    indexType: AssetIndexTypes;
    inputFields: Field[];
    projects$: Observable<Project[]>;
    projectCurrencies$: Observable<ProjectCurrency[]>;
    locations$: Observable<Location[]>;
    sets$: Observable<Set[]>;
    subDepartments$: Observable<SubDepartment[]>;
    transactions: Transaction[];
}

@Component({
    templateUrl: './create-asset-from-trx-modal.component.html',
    styleUrls: ['create-asset-from-trx-modal.component.scss'],
    standalone: false
})
export class CreateAssetFromTrxModalComponent implements OnInit {
    characters$: Observable<Character[]> = observableOf([]);
    departments$: Observable<Department[]> = observableOf([]);
    dispositions$: Observable<Disposition[]> = observableOf([]);
    excludedDispositions$: Observable<Disposition[]> = observableOf([]);
    franchise: Franchise;
    indexType: AssetIndexTypes;
    inputFields: Field[];
    projects$: Observable<Project[]> = observableOf([]);
    projectCurrencies$: Observable<ProjectCurrency[]> = observableOf([]);
    locations$: Observable<Location[]> = observableOf([]);
    sets$: Observable<Set[]> = observableOf([]);
    subDepartments$: Observable<SubDepartment[]> = observableOf([]);
    transactions: Transaction[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) private data: CreateAssetFromTrxModalData, public dialogRef: MatDialogRef<CreateAssetFromTrxModalComponent>) { }

    ngOnInit() {
        this.characters$ = this.data.characters$;
        this.departments$ = this.data.departments$;
        this.dispositions$ = this.data.dispositions$;
        this.excludedDispositions$ = this.data.excludedDispositions$;
        this.franchise = this.data.franchise;
        this.indexType = this.data.indexType;
        this.inputFields = this.data.inputFields;
        this.projects$ = this.data.projects$;
        this.projectCurrencies$ = this.data.projectCurrencies$;
        this.locations$ = this.data.locations$;
        this.sets$ = this.data.sets$;
        this.subDepartments$ = this.data.subDepartments$;
        this.transactions = this.data.transactions;

    }

    close() {
        this.dialogRef.close();
    }
}
